import React, { Fragment } from 'react';
import { useParams, Link } from 'react-router-dom'
import { useArticle } from '../../hooks/useAirtableArticles';
import Navbar from '../../components/Navbar/Navbar';
import BlogSingle from '../../components/BlogDetails/BlogSingle.jsx'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import logo from '../../images/logo-2.svg';
import './BlogDetailsFull.scss';

const BlogDetailsFull = () => {
    const { slug } = useParams()
    
    // Fetch from Airtable
    const { article, loading, error } = useArticle(slug);
    
    if (loading) {
        return (
            <Fragment>
                <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} isSecondary={true} />
                <div className="container py-5">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading article...</span>
                        </div>
                    </div>
                </div>
                <Footer hclass={'wpo-site-footer_s2'} />
                <Scrollbar />
            </Fragment>
        );
    }
    
    if (error || !article) {
        return (
            <Fragment>
                <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} isSecondary={true} />

                {/* Hero Section */}
                <section className="blog-detail-hero-section" style={{ backgroundImage: 'url(/blog-banner.jpg)' }}>
                    <div className="hero-overlay"></div>
                    <div className="container">
                        <div className="hero-content">
                            <h1>Blog Temporarily Unavailable</h1>
                        </div>
                    </div>
                </section>

                <div className="container py-5">
                    <div className="text-center">
                        <div className="alert alert-info">
                            <h2>Blog Article Unavailable</h2>
                            <p className="mb-3">We're experiencing technical difficulties accessing this article.</p>
                            <p>Please try again later or contact us for more information.</p>
                            <Link to="/blog" className="btn btn-primary me-3">Back to Blog</Link>
                            <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
                        </div>
                    </div>
                </div>
                <Footer hclass={'wpo-site-footer_s2'} />
                <Scrollbar />
            </Fragment>
        );
    }
    
    // Get the display image (featured image or first image from array)
    const displayImage = article.featuredImage || 
        (article.images && article.images.length > 0 ? article.images[0].url : null);
    
    return (
        <Fragment>
            <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} isSecondary={true} />

            {/* Hero Section */}
            <section
                className="blog-detail-hero-section"
                style={{
                    backgroundImage: displayImage ? `url(${displayImage})` : 'url(/blog-banner.jpg)'
                }}
            >
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="hero-content">
                        <h1>{article.title || article.title2 || 'Blog Article'}</h1>
                    </div>
                </div>
            </section>

            <BlogSingle blLeft={'d-none'} blRight={'col-lg-10 offset-lg-1'} />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetailsFull;